import { skip } from "rxjs/operators";
import { ConstantsQualityLevel } from "../../../app/utilities/constants/constants.interface";

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectBasicAreasCtrl', ProjectBasicAreasCtrl);

  ProjectBasicAreasCtrl.$inject = ['$scope', '$location', 'Utils', 'Auth', 'Project',
    'project', 'Constants', '$mdDialog', 'BasicAreaLogic', 'Labels', '$injector', 'sg2AreaTemplateService', 'sg2ProjectService'];

  function ProjectBasicAreasCtrl ($scope, $location, Utils, Auth, Project, project,
    Constants, $mdDialog, BasicAreaLogic, Labels, $injector, sg2AreaTemplateService, sg2ProjectService) {
    const vm = this;

    vm.$onInit = () => {
      vm.LABELS = Labels;
      vm.qualityLevels = Constants.getList('QUALITY_LEVELS');
      vm.canWrite = Utils.canWriteProject(Auth.getCurrentUser(), {
        accessLevel: null,
        projectLevels: ['manager', 'contributor'],
        project: project
      });

      setTimeout(() => {
        $scope.sg2AuthService = $injector.get('sg2AuthService');
      }, 100);

      vm.initBasicArea(project);
    };

    // Subscribe to project changes to detect deletion of an area template.
    // On update, replace the $scope's project with the updated project from the datastore.
    // @note Somehow it need *two* skpis instead of one, don't know why, but it works.
    // @note When navigating from areatemplate to areatemplate-detail page, this controller
    //  is still active. Added dirty solution to only fire on overview page.
    sg2ProjectService.project$.pipe(skip(2)).subscribe(p => {
      if (location.href.split('/').pop() === 'basic-areas') {
        vm.initBasicArea(p);
      }
    });

    /**
     *
     * @param {Object} basicArea - contains a single instance of the basic Area
     * @returns {String} - template name
     */
    vm.checkTemplate = (basicArea) => {
      if (typeof basicArea.templateId === 'string') {
        // SPEC-2841
        // Data is enriched by old controllers/helpers with circular deps (id's are replaced with objects).
        // This is not the case in the new datastore, so after updating an areatemplate on a new page (like
        // the detail page), these objects are removed, thus breaking this code. Fixing is very time consuming,
        // so just remove the error, and fix at a later time (i.e. replace the whole page).
      } else {
        return basicArea.templateId.isParent ? basicArea.templateId.name : basicArea.templateId.parentId.name;
      }
    };

    $scope.$on('projectUpdate-' + project._id, (event, updatedProj) => {
      // vm.initBasicArea(updatedProj);
    });

    /**
     * openBasicArea()
     * @param {Number} index - index in the column data
     * @param {String} id  - returns the id of the basicArea
     *
     * Used to open the mdDialog containing the correct basicArea.
     */
    // index needs to be set as it's been defined in the (sgTable) columnClickHandler function
    vm.openBasicAreaPage = (index, id) => {
      const basicArea = vm.basicAreas.find((t) => t._id === id);
      vm.openBasicArea(basicArea);
    };

    vm.initBasicArea = (proj) => {
      vm.basicAreas = BasicAreaLogic.filterInactive(proj.basicAreas);
      vm.basicAreas.forEach((bArea) => {
        BasicAreaLogic.backupQualityLevel(bArea);
        BasicAreaLogic.setAreaCount(proj, bArea);
        // Based  on the original sgBasicAreasListTable.html
        // If no area found, show a dash instead of the integer 0
        bArea.areaCount = bArea.hasArea ? bArea.areaCount : '-';

        // Separate the template data from the templateId object.
        // WIP: Broken template should be ignored, not sure if this is the best way to catch this issue...
        if (angular.isDefined(bArea.templateId) && bArea.templateId !== null) {
          bArea.templateName = vm.checkTemplate(bArea);
          bArea.areaTemplateName = bArea.templateId.name;
        }
      });
    };


    /**
     * confirmQualityLevelEdit
     * User needs to confirm the quality level change
     */
    const confirmQualityLevelEdit = () => {
      const confirm = $mdDialog
        .confirm()
        .title(vm.LABELS.getLabelCapFirstLetter('areyousurechangeareatemplatequalitylevel'))
        .textContent(vm.LABELS.getLabelCapFirstLetter('areyousurechangeareatemplatequalitylevelexplanation'))
        .ok(vm.LABELS.getLabelCapFirstLetter('ok'))
        .cancel(vm.LABELS.getLabelCapFirstLetter('cancel'));

      return $mdDialog.show(confirm);
    };

    /**
     * submitNewQualitylevel
     * @param {Object} basicArea - Object returned is the basic-area containing the new quality level.
     *
     * When the qualitylevel has been changed, make sure to update/store the changes accordingly.
     */
    vm.submitNewQualityLevel = (basicArea) => {
      // Before any changes can be made, the user MUST accept the change.
      confirmQualityLevelEdit()
        .then(() => {
          // Update the basicArea
          const updateArea = {
            _id: project._id,
            versionId: project.versionId,
            basicArea: {
              basicAreaId: basicArea._id,
              qualityLevel: basicArea.qualityLevel
            }
          };

          Project.editBasicArea(updateArea).$promise.then((updatedProj) => {
            vm.initBasicArea(updatedProj);
          });
        })
        .catch(() => {
          basicArea.qualityLevel = basicArea.originalQualityLevel;
        });
    };

    /**
     * Get quality level display name from value.
     *
     * @note In Angular2 there's a pipe for this, but you can't downgrade those.
     *
     * @param value The quality level value
     * @returns The quality level display name.
     */
    vm.getQualityLevelDisplayName = (value: ConstantsQualityLevel['value']): ConstantsQualityLevel['displayName'] => {
      return vm.qualityLevels.find(ql => ql.value === value)?.displayName;
    };

    // tableColumns object is used to set the dynamic filter table
    vm.tableColumns = [{
      headerTitle: Labels.getLabel('areatemplatename'),
      type: 'string',
      sortable: true,
      filterData: vm.basicAreas,
      displayKey: 'name',
      columnClickHandler: vm.openBasicAreaPage,
      thClass: 'sg-mat-table__cell--basicareaname',
      columnFilter: true,
    },
    {
      headerTitle: Labels.getLabel('qualitylevel'),
      type: 'multiSelect',
      sortable: true,
      template: 'app-legacy/project/basic-areas/basic-areas-template/qualitylevels.template.html',
      filterData: Constants.getList('QUALITY_LEVELS'),
      optionDisplayKey: 'displayName',
      displayKey: 'qualityLevel',
      optionValueKey: 'value',
      thClass: 'sg-mat-table__cell--qualitylevel',
      columnFilter: true,
    },
    {
      headerTitle: Labels.getLabel('areatemplatecategory'),
      type: 'string',
      sortable: true,
      filterData: vm.basicAreas,
      displayKey: 'templateName',
      columnClickHandler: vm.openBasicAreaPage,
      thClass: 'sg-mat-table__cell--areatemplatecategory',
      columnFilter: true,
    },
    {
      headerTitle: Labels.getLabel('originalareatemplate'),
      type: 'string',
      sortable: true,
      filterData: vm.basicAreas,
      displayKey: 'areaTemplateName',
      columnClickHandler: vm.openBasicAreaPage,
      thClass: 'sg-mat-table__cell--areatemplate',
      columnFilter: true,
    },
    {
      headerTitle: Labels.getLabel('numberofareas'),
      filterData: vm.basicAreas,
      displayKey: 'areaCount',
      columnClickHandler: vm.openBasicAreaPage,
      thClass: 'sg-mat-table__cell--numberofareas',
      columnFilter: true,
    },
    {
      headerTitle: Labels.getPlural('option'),
      tdClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      thClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      template: 'app-legacy/project/basic-areas/basic-areas-template/basic.areas.options.template.html',
      columnFilter: true,
    }];

    vm.tablePagination = {
      resultLimitDropdown: {
        enabled: true,
        limit: [10, 20, 50, 100, 250]
      },
      resultLimit: 10
    };

    vm.columnFilters = {
      enabled: true
    }

    /* ========================================================================
    ================================== methods ================================
    ======================================================================== */

    vm.addBasicArea = function () {
      $mdDialog.show({
        controller: 'AddBasicAreaController',
        controllerAs: '$addBasicAreaCtrl',
        locals: {
          project: project,
          qualityLevels: Constants.getList('QUALITY_LEVELS')
        },
        resolve: {
          areaTemplates: ['AreaTemplateAPI', (AreaTemplateAPI) => AreaTemplateAPI.getAll().$promise],
        },
        templateUrl: 'app-legacy/project/basic-areas/add-basic-area/add.basic.area.tpl.html',
        clickOutsideToClose: true,
      });
    };

    vm.deleteBasicArea = (basicArea, evt) => {
      evt.stopPropagation();
      sg2AreaTemplateService.delete(basicArea, true);
    };

    vm.openBasicArea = function (basicArea) {
      const newPath = Utils.path.concat($location.path(), '/', basicArea._id);
      $location.path(newPath);
    };
  }

})();
